<template>
  <div class="preloader" :style="{ 'background-color': bgcolor }">
    <b-container fluid>
      <div id="animated_div">
        <div class="loading-img-container">
          <c-spinner :isLoading="isLoading" color="#f1f2f3"/>
           <div class="loading-text"> <!--Loading-text-->
              <h4>LOADING
                <span class="dot-one"> .</span>
                <span class="dot-two"> .</span>
                <span class="dot-three"> .</span>
              </h4>
            </div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import cSpinner from '@/components/Spinner.vue'

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    bgcolor: {
      type: String,
      default: 'rgba(#fff, .9)'
    }
  },
  components: {
    cSpinner
  }
}
</script>

<style lang="scss" scoped>
.preloader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10000;
  // background: rgba(#2f3137, .9);
  text-align: center;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  p {
    color: rgba(#fff, .75);
    margin-top: 30px;
  }
}
.loading-img-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
#animated_div{
  width: 100%;
  height: 100%;
  background: url('../assets/img/star.png') repeat-x;
  background-size:cover;
  -webkit-animation: animatebackground 60s linear infinite;
  animation: animatebackground 60s linear infinite;
  -ms-animation: animatebackground 60s linear infinite;
  -moz-animation: animatebackground 60s linear infinite;
    @media screen and (min-width: 320px) {
      min-height: 900px;
    }
    @media screen and (min-width: 768px) {
        min-height: 550px;
    }
    @media screen and (min-width: 1440px) {
      min-height: 1200px;
    }
    @media screen and (min-width: 1920px) {
    }
  }
  @keyframes animatebackground
  {
   from {background-position: 0 0;}
   to {background-position: -1000px 0;}
  }

  @-webkit-keyframes animatebackground
  {
   from {background-position: 0 0;}
   to {background-position: -1000px 0;}
  }

  @-ms-keyframes animatebackground
  {
   from {background-position: 0 0;}
   to {background-position: -1000px 0;}
  }

  @-moz-keyframes animatebackground
  {
   from {background-position: 0 0;}
   to {background-position: -1000px 0;}
  }

.loading-text{
  color: #ffffff;
  font-size: 34px;
  margin-top: 34px;
  position: relative;
  left: -23px;
}

h4.loading{
  font-size: 34px;
  font-weight: 700;
  color: #ffffff;
}
span[class^="dot-"]{
  opacity: 0;
}
.dot-one{
  animation: dot-one 2s infinite linear
}
.dot-two{
  animation: dot-two 2s infinite linear
}
.dot-three{
  animation: dot-three 2s infinite linear
}
@keyframes dot-one{
  0%{
    opacity: 0;
  }
  15%{
    opacity: 0;
  }
  25%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}

@keyframes dot-two{
  0%{
    opacity: 0;
  }
  25%{
    opacity: 0;
  }
  50%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}

@keyframes dot-three{
  0%{
    opacity: 0;
  }
  50%{
    opacity: 0;
  }
  75%{
    opacity: 1;
  }
  100%{
    opacity: 1;
  }
}
</style>
